/**
 * MIT Sloan Management SSO
 */
const tp = window.tp || [];
const config = window.SMR_SSO_Config || {};

(function ($) {
  const $modal = $(".modal");
  const $modalContent = $(".modal__content");
  const $modalContainer = $(".modal__container");
  const $loading = $(".modal__loading");
  const $pianoContainer = $(`[data-piano-container]`);
  const $modalPianoLinks = $(".modal-piano__links");

  function loading(show) {
    if (show) {
      $modal.removeClass("is-ready").addClass("is-loading");
    } else {
      $modal.removeClass("is-loading").addClass("is-ready");
    }
  }

  class SMR_SSO {
    constructor() {
      this.close();
      this.modals();
      this.pianoEvents();
      this.login();
      this.register();
      this.business();
      this.logout();
      this.myaccount();
      this.observePianoContainer();
    }

    observePianoContainer() {
      this.pianoContainerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const removed = mutation.removedNodes.length > 0;
          if (removed) {
            const node = mutation.removedNodes[0];
            loading(true);
          }

          const added = mutation.addedNodes.length > 0;
          if (added) {
            const node = mutation.addedNodes[0];
            setTimeout(function () {
              loading(false);
            }, 1000);
          }
        });
      });

      this.pianoContainerObserver.observe($pianoContainer.get(0), {
        subtree: false,
        childList: true,
        attributes: false,
      });
    }

    pianoEvents() {
      tp.push([
        "addHandler",
        "loginRequired",
        (params) => {
          $(document).trigger("piano:login-open", {
            screen: "login",
          });
          return false;
        },
      ]);
    }

    modals() {
      screen = "login";

      MicroModal.init({
        openTrigger: "data-modal-open",
        closeTrigger: "data-modal-close",
        disableFocus: true,
        debugMode: false,
        onShow: (modal) => {
          this.hideMobileMenu();
          $("body").addClass("modal--lock");
          if (modal.id === "modal-piano") {
            $(`[data-piano-toggle="${screen}"]`).trigger("click");
          }
          $(document).on("keyup", this.escapeClose);
        },
        onClose: (modal) => {
          $("body").removeClass("modal--lock");
          $modal.removeClass("is-ready");
          screen = "login";
          $(document).off("keyup", this.escapeClose);
          $pianoContainer.find(".piano-id-container").remove();
          loading(false);
        },
      });

      $(document).on("click", `[data-piano-toggle]`, (event) => {
        event.preventDefault();
        const $this = $(event.currentTarget);
        const target = $this.data("piano-toggle");
        const modalClass = $modal.attr("class");
        const updatedModalClass = modalClass.replace(/(modal--[^\s]+)/m, `modal--${target}`);
        $modal.attr("class", updatedModalClass);
        loading(true);
      });

      // Modal w/screen
      $(document).on("click", `[data-piano-modal]`, (event) => {
        event.preventDefault();
        screen = $(event.currentTarget).data("piano-modal");
        MicroModal.show("modal-piano", {
          onShow: (modal) => {
            $(`[data-piano-toggle="${screen}"]`).trigger("click");
          },
          onClose: (modal) => {
            loading(false);
          },
        });
      });

      this.externalTriggers();
    }

    myaccount() {
      if (location.pathname !== "/edit-profile/") return;

      // User is logged in, show my profile screen
      if (tp.pianoId.isUserValid()) {
        tp.myaccount.show({
          displayMode: "inline",
          containerSelector: `.piano-account`,
        });
        return;
      }

      // Login required
      $(".piano-account .loading-spinner").css("visibility", "hidden");
      MicroModal.show("modal-piano", {
        onShow: (modal) => {
          $('[data-piano-toggle="login"]').trigger("click");
        },
        onClose: (modal) => {
          loading(false);
        },
      });
    }

    externalTriggers() {
      const screens = ["login", "register", "business"];

      // Login > Open
      $(document).on("piano:login-open", (event, options) => {
        if (options.hasOwnProperty("screen") && $.inArray(options.screen, screens)) {
          screen = options.screen;
        }

        MicroModal.show("modal-piano");
        // specific workaround for the Offer page overlay (/subscribe/)
        if($("[allow=payment]").length > 1) {
            $('.modal-piano').css("display", "none");
        }
      });

      // Login > Close
      $(document).on("piano:login-close", (event, options) => {
        MicroModal.close("modal-piano");
      });
    }

    // Close icon
    close() {
      $(document).on("click", "[data-modal-close]", (event) => {
        event.preventDefault();
        MicroModal.close("modal-piano");
      });
    }

    escapeClose(e) {
      if (e.key == "Escape") {
        MicroModal.close("modal-piano");
      }
    }

    // Hide mobile menu (pulled from theme)
    hideMobileMenu() {
      if (!$(".main-menu.isOpened").length) return;

      $(".secondary-menu, .user-menu").removeClass("isOpened");
      $(".secondary-menu__options").hide();
      $(".main-menu__container, .main-menu__large-search-form, .site-header--hamburger-isOpened .site-nav__group .site-nav__option, .site-header--hamburger-isOpened .user-menu").hide();
      $(".main-menu").removeClass("isOpened");
      $(".site-header").removeClass("site-header--hamburger-isOpened");
      $(".nav-hamburger__menu-options").removeClass("nav-hamburger__menu-options--active");
      $(".site-nav__group, .main-menu__large-search-form, .nav-hamburger__menu-title, .nav-hamburger__promo").removeClass("nav-hidden-elements");
      $(".site-nav__group .site-nav__option, .user-menu").show();
    }

    // Show login
    pianoShowLogin() {
      tp.pianoId.show({
        displayMode: "inline",
        screen: "login",
        disableSignUp: true,
        observeContainer: true,
        containerSelector: `[data-piano-container]`,
        loginDisplayed: () => {
          loading(false);
        },
      });
    }

    // Login
    login() {
      $(`[data-piano-toggle="login"]`).on("click", (event) => {
        event.preventDefault();

        // Avoid misfires for users already logged-in
        if (tp.pianoId.isUserValid()) {
          tp.pianoId.logout(() => {
            this.pianoShowLogin();
          });
          return;
        }

        // Login for non-authenticated users
        this.pianoShowLogin();
      });
    }

    // Register
    register() {
      $(`[data-piano-toggle="register"]`).on("click", (event) => {
        event.preventDefault();
        tp.pianoId.show({
          displayMode: "inline",
          disableSignUp: false,
          screen: "register",
          observeContainer: true,
          containerSelector: `[data-piano-container]`,
          registerDisplayed: () => {
            loading(false);
          },
        });
      });
    }

    // Business (modal tab)
    business() {
      $(document).on("click", `[data-piano-toggle="business"]`, (event) => {
        $modalContent.removeAttr("style");

        const template = $.get(`${config.plugin_dir_path}/templates/modal-piano__business.php`, {
          cache: true,
        });

        template.done((html, textStatus, jqXHR) => {
          $pianoContainer.html(html);
        });

        template.fail((jqXHR, textStatus, errorThrown) => {
          $pianoContainer.html(`<div class="modal-piano__error"><p>Error: ${errorThrown}</p></div>`);
        });

        template.done(() => {
          loading(false);
        });
      });

      $(document).on("submit", `[data-piano="business-login"]`, (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        const $form = $(form);
        const $success = $(`[data-piano="success"]`, form);
        const $error = $(`[data-piano="error"]`, form);

        $success.hide();
        $error.hide();

        const payload = {
          email: $('input[type="email"]', form).val(),
          referer: location.href,
        };

        const req = $.ajax({
          url: "/api/smr-sso/business-login/",
          type: "PUT",
          data: payload,
          dataType: "json",
          accepts: {
            json: "application/json",
          },
        });

        // Success
        req.done((data) => {
          $success.find("p").html(data.notice);
          $success.fadeIn();
        });

        // Errors
        req.fail((jqXHR, textStatus, errorThrown) => {
          const response = $.parseJSON(jqXHR.responseText);
          $error.find("p").html(response.notice);
          $error.fadeIn();
          console.fail(response.error.data.response.errors);
        });
      });
    }

    // Logout
    logout() {
      $(document).on("click", ".p-logout", (e) => {
        e.preventDefault();

        // Piano
        if (tp.pianoId.isUserValid()) {
          tp.pianoId.logout(() => {
            location.reload();
          });
          return;
        }

        // WordPress
        const wordpressLogoutHref = $("#wp-admin-bar-logout a").attr("href");
        if (wordpressLogoutHref != undefined) {
          location.href = $wpLogout.attr("href");
        }
      });
    }
  }

  tp.push(["setUsePianoIdUserProvider", true]);

  tp.push([
    "init",
    function () {
      new SMR_SSO();
    },
  ]);
})(window.jQuery);
